export const courseEnrolmentStatuses = {
    PENDING: 'Pending',
    CURRENT: 'Current',
    INACTIVE: 'Inactive',
    COMPLETED: 'Completed',
    TRANSFERRED: 'Transferred',
    WITHDRAWN: 'Withdrawn',
    CANCELLED: 'Cancelled',
};

export const reasonTypesList = [
    {
      value: 'COURSE_NOT_SUITABLE',
      name: 'Course Was Not Suitable'
    },
    {
      value: 'PERSONAL',
      name: 'Personal',
    },
    {
      value: 'PROMO_ERROR',
      name: 'Referral/Promo Code Error',
    },
    {
      value: 'WORK',
      name: 'Work Commitments',
    },
    {
      value: 'COURSE_CANCELLED',
      name: 'Course was cancelled',
    },
    {
      value: 'COURSE_UPGRADE',
      name: 'Course Upgrade',
    },
    {
      value: 'COURSE_DOWNGRADE',
      name: 'Course Downgrade',
    },
    {
      value: 'USER_INTERVIEW',
      name: 'User Interviews',
    },
    {
      value: 'FINANCIAL_PROBLEMS',
      name: 'Financial Problems',
    },
    {
      value: 'TIME_ZONE_PROBLEMS',
      name: 'Time Zone Problems',
    },
    {
      value: 'TECHNICAL',
      name: 'Technical Issues',
    },
    {
      value: 'MINOR',
      name: 'Minor, Too Young',
    },
    {
      value: 'POOR_EXPERIENCE',
      name: 'Poor Experience',
    },
    {
      value: 'COVID',
      name: 'COVID Delayed Class',
    },
    {
      value: 'FRAUD',
      name: 'Fraud',
    },
    {
      value: 'CUSTOM',
      name: 'Other',
    },
  ];

export const refundMethodsList = [
    {
      value: 'Stripe',
      name: 'Stripe',
    },
    {
      value: 'Paypal',
      name: 'Paypal',
    },
    {
      value: 'Rapyd',
      name: 'Rapyd (bank transfer)',
    },
  ];

export const validEnrolmentStatuses = [courseEnrolmentStatuses.PENDING, courseEnrolmentStatuses.CURRENT, courseEnrolmentStatuses.COMPLETED];
